import { data } from "./data";

export const getProjectData = (projectTitle) => {
  return data[projectTitle];
};

export const getEnhancedCoverImages = () => {
  const projects = Object.values(data);

  return projects.map((project) => {
    return project.enhancedCoverImage;
  });
};

export const getCarouselImages = () => {
  const projects = Object.values(data);

  return projects.map((project) => {
    return project.carouselImage;
  });
};

export const getProjectNameFromPath = (pathname) => {
  const pathSegments = pathname.split("/");

  return pathSegments[pathSegments.length - 1];
};

export const getAllProjectData = () => {
  const projects = Object.values(data);

  return projects.map((project) => project);
};
